import { Badge, Card, CardBody } from "reactstrap"
import SectionHeader from "components/Common/SectionHeader"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import ImageViewer from "components/Common/ImageViewer/ImageViewer"
import OnboardingConfirmationUpdate from "./OnboardingConfirmationUpdate"
import { useState } from "react"

const SLOTS = [
  { key: "chassis_image", label: "Chassis" },
  { key: "engine_image", label: "Engine" },
  { key: "tire_image", label: "Tire Size" },
]

export default function OnboardingConfirmation({ stock, loading = false }) {
  const [viewerOpen, setViewerOpen] = useState(false)
  const [viewerIndex, setViewerIndex] = useState(0)

  const present = SLOTS.map(s => ({ ...s, url: stock?.[s.key]?.url || null })).filter(s => s.url)
  const presentUrls = present.map(s => s.url)

  const openViewer = url => {
    setViewerIndex(Math.max(0, presentUrls.indexOf(url)))
    setViewerOpen(true)
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-check-shield"
          title="Onboarding Confirmation"
          action={loading ? null : <OnboardingConfirmationUpdate stock={stock} />}
        />

        <div className="row g-2">
          {SLOTS.map(({ key, label }) => {
            const url = stock?.[key]?.url || null
            return (
              <div key={key} className="col-4 text-center">
                {loading ? (
                  <ThemePlaceholder style={{ width: "100%", height: 90, borderRadius: 6 }} />
                ) : url ? (
                  <img
                    src={url}
                    alt={label}
                    onClick={() => openViewer(url)}
                    className="w-100 rounded-2"
                    style={{ height: 90, objectFit: "cover", cursor: "pointer" }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded-2"
                    style={{ height: 90 }}
                  >
                    <i className="bx bx-camera fs-3 text-muted"></i>
                  </div>
                )}
                <div className="small mt-1">
                  {url ? (
                    <span className="text-muted">{label}</span>
                  ) : (
                    <Badge color="secondary">{label}</Badge>
                  )}
                </div>
              </div>
            )
          })}
        </div>

        <ImageViewer
          images={presentUrls}
          initialIndex={viewerIndex}
          isOpen={viewerOpen}
          onClose={() => setViewerOpen(false)}
          title="Onboarding Confirmation"
        />
      </CardBody>
    </Card>
  )
}
